module.exports = __webpack_public_path__ + "img/inseegroup-laodl-800x800.fa5dbea5.jpg";